import { Timestamp } from 'firebase/firestore';

/**
 * Calculates the active days of the week for a streak.
 * @param streak - The number of days in the streak.
 * @param lastDay - The date of the last completed session.
 * @returns An array of numbers representing the days of the week (0=Sun, 6=Sat).
 */
export const getActiveDays = (
  streak: number,
  lastDay?: Timestamp | Date | string | null
): number[] => {
  if (!lastDay || streak === 0) {
    return [];
  }

  let lastDate: Date;
  if (lastDay instanceof Timestamp) {
    lastDate = lastDay.toDate();
  } else if (typeof lastDay === 'string') {
    lastDate = new Date(lastDay);
  } else {
    lastDate = lastDay;
  }

  // Check if the last session was today or yesterday
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const lastDateMidnight = new Date(lastDate);
  lastDateMidnight.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - lastDateMidnight.getTime();
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  // If the last session was more than 1 day ago, the streak is broken, show nothing.
  if (diffDays > 1) {
    return [];
  }

  const lastDayIndex = lastDate.getDay(); // 0 (Sun) to 6 (Sat)

  // Calculate the day index for each day in the streak, counting backwards.
  // The `+ 7` ensures the number is non-negative for a correct modulo wrap-around.
  return Array.from({ length: streak }, (_, i) => (lastDayIndex - i + 7) % 7);
};
